import { PusherEvent } from '@mondaygpt/constants'
import { useEffect, useRef } from 'react'
import { usePusher } from '../contexts'

export const useListenToPusherEvent = <T>(eventType: PusherEvent, callback: (data: T) => void) => {
  const { userChannel } = usePusher()
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => {
    if (!userChannel) return

    const handler = (data: T) => callbackRef.current(data)
    userChannel.bind(eventType, handler)

    return () => {
      userChannel.unbind(eventType, handler)
    }
  }, [eventType, userChannel])
}
